export const translations = {
  es: {
    nav: { works: "Obras", exhibitions: "Exposiciones", about: "Artista", contact: "Contacto", admin: "Admin" },
    home: {
      eyebrow: "Estudio · 2026",
      hero1: "Pintura",
      hero2: "contemporánea",
      hero3: "para coleccionar.",
      lead: "Obras únicas en acrílico, óleo y técnica mixta. Cada pieza es original, firmada y enviada con certificado de autenticidad.",
      explore: "Ver obras",
      featured: "Obra destacada",
      view: "Ver detalle",
      latestWorks: "Obras recientes",
      seeAll: "Ver catálogo completo",
      upcoming: "Próximas exposiciones",
      seeAllExh: "Ver todas",
    },
    works: {
      title: "Catálogo",
      subtitle: "Obras disponibles y de archivo. Haz clic para conocer cada pieza.",
      sold: "Vendida",
      available: "Disponible",
    },
    detail: {
      year: "Año",
      technique: "Técnica",
      dimensions: "Medidas",
      price: "Precio",
      buy: "Comprar obra",
      buying: "Procesando...",
      sold: "Obra vendida",
      back: "Volver al catálogo",
      description: "Descripción",
      certificate: "Incluye certificado de autenticidad firmado por la artista.",
    },
    exhibitions: {
      title: "Exposiciones",
      subtitle: "Próximas muestras individuales y colectivas.",
      none: "Sin exposiciones programadas por el momento.",
    },
    about: {
      title: "La artista",
      contact_label: "Contacto",
    },
    contact: {
      title: "Contacto",
      subtitle: "Para consultas sobre obras, encargos o exposiciones, escribe directamente al estudio.",
      email: "Email",
      instagram: "Instagram",
    },
    success: {
      title: "Compra confirmada",
      sub: "Recibirás un email con los detalles del envío.",
      back: "Volver al inicio",
      processing: "Verificando pago...",
      failed: "El pago no se pudo confirmar.",
    },
    admin: {
      login: "Acceder",
      email: "Email",
      password: "Contraseña",
      logout: "Cerrar sesión",
      dashboard: "Panel",
      artworks: "Obras",
      exhibitions: "Exposiciones",
      add: "Añadir",
      edit: "Editar",
      delete: "Eliminar",
      save: "Guardar",
      cancel: "Cancelar",
      invalidCreds: "Credenciales incorrectas",
    },
    footer: {
      rights: "Todos los derechos reservados.",
    },
  },
  en: {
    nav: { works: "Works", exhibitions: "Exhibitions", about: "Artist", contact: "Contact", admin: "Admin" },
    home: {
      eyebrow: "Studio · 2026",
      hero1: "Contemporary",
      hero2: "painting",
      hero3: "for collectors.",
      lead: "Unique works in acrylic, oil and mixed media. Each piece is original, signed and shipped with a certificate of authenticity.",
      explore: "See works",
      featured: "Featured work",
      view: "View detail",
      latestWorks: "Recent works",
      seeAll: "Full catalogue",
      upcoming: "Upcoming exhibitions",
      seeAllExh: "See all",
    },
    works: {
      title: "Catalogue",
      subtitle: "Available works and archive. Click any piece to learn more.",
      sold: "Sold",
      available: "Available",
    },
    detail: {
      year: "Year",
      technique: "Technique",
      dimensions: "Dimensions",
      price: "Price",
      buy: "Buy artwork",
      buying: "Processing...",
      sold: "Sold",
      back: "Back to catalogue",
      description: "Description",
      certificate: "Includes a certificate of authenticity signed by the artist.",
    },
    exhibitions: {
      title: "Exhibitions",
      subtitle: "Upcoming solo and group shows.",
      none: "No exhibitions scheduled at the moment.",
    },
    about: {
      title: "The artist",
      contact_label: "Contact",
    },
    contact: {
      title: "Contact",
      subtitle: "For inquiries about works, commissions or exhibitions, write directly to the studio.",
      email: "Email",
      instagram: "Instagram",
    },
    success: {
      title: "Purchase confirmed",
      sub: "You'll receive an email with shipping details.",
      back: "Back to home",
      processing: "Verifying payment...",
      failed: "Payment could not be confirmed.",
    },
    admin: {
      login: "Sign in",
      email: "Email",
      password: "Password",
      logout: "Sign out",
      dashboard: "Dashboard",
      artworks: "Works",
      exhibitions: "Exhibitions",
      add: "Add",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      invalidCreds: "Invalid credentials",
    },
    footer: {
      rights: "All rights reserved.",
    },
  },
};
